<!-- 联系我们 -->
<template>
  <div class="contact">
    <v-head :bg="'#181818'"></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner -->
      <div class="contact-banner">
        <div class="contact-banner-img" :style="'background-image:url(' + img + ')'">
          <div class="contact-banner-zz"></div>
        </div>
        <!-- <img :src="img" alt width="100%" height="100%" /> -->
        <div class="banner-message">
          <div class="banner-message-title">联系我们</div>
          <div class="banner-message-main">我们致力于给您提供个性化的进校园商业服务，任何问题请联系我们</div>
          <div class="banner-message-phone">
            <el-button size="small">010-53601282</el-button>
          </div>
        </div>
      </div>
      <!-- 联系我们-详细信息 -->
      <div class="contact-details">
        <!-- left -->
        <div class="details-intro">
          <!-- left-top -->
          <div class="details-intro-t">
            <div class="intro-t-title">
              <i class="el-icon-service"></i>联系客服
            </div>
            <div class="intro-t-msg">联系客服获取更多服务</div>
            <div class="intro-t-contact">
              <div class="contactQQ">
                腾讯QQ
                <span>1571719039</span>
              </div>
              <div class="contactPhone">
                联系电话
                <span>010-53601282</span>
              </div>
              <div class="contactEmail">
                邮箱地址
                <span>service@nauac.com</span>
              </div>
            </div>
          </div>
          <!-- left-bottom -->
          <div class="details-intro-b">
            <div class="intro-b-title">
              <i class="el-icon-location-outline"></i>联系地址
            </div>
            <div class="intro-b-msg">联系地址与工作时间</div>
            <div class="intro-b-contact">
              <div class="contactDate">
                工作时间
                <span>09:00-18:00</span>
              </div>
              <div class="contactAddress">
                公司地址
                <span>北京市海淀区中关村创业大街6号楼4层</span>
              </div>
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="details-map">
          <div class="mapContent">
            <!-- <img :src="imgMap" alt width="100%" height="100%" /> -->
            <div class="mapContent-map" :style="'background-image:url(' + imgMap + ')'"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import bg from '@/assets/img/lx-bg.jpg'
import bgMap from '@/assets/img/lx-bg-1.jpg'
import {
  Button,
  Row,
  Col
} from 'element-ui'
export default {
  data () {
    return {
      img: bg, // 临时图片
      imgMap: bgMap
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-row': Row,
    'el-col': Col
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.contact {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .contact-banner {
    width: 100%;
    height: 450px;
    position: relative;
    .contact-banner-img {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      .contact-banner-zz {
        background-color: rgba(0, 0, 0, 0.7);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
    .banner-message {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding-top: 60px;
      box-sizing: border-box;
      .banner-message-title {
        font-size: 18px;
        color: #ffffff;
        padding: 18px 0;
      }
      .banner-message-main {
        font-size: 12px;
        color: #ffffff;
        padding: 15px 0;
      }
      .banner-message-phone {
        padding: 22px 0;
        button {
          background-color: #2078ec;
          color: #ffffff;
          border: 0;
          border-radius: 0;
          padding: 10px 20px;
        }
      }
    }
  }
  // 联系我们-详细信息
  .contact-details {
    width: 70%;
    height: 550px;
    margin: 0 auto;
    // background-color: #cccccc;
    display: flex;
    flex-direction: row;
    .details-intro {
      flex: 1;
      // background-color: red;
      .details-intro-t {
        height: 50%;
        width: 80%;
        margin: 0 auto;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        padding: 75px 25px 25px 50px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .intro-t-title {
          font-size: 14px;
          color: #666;
          font-weight: 700;
          padding: 10px 0;
          position: relative;
          display: flex;
          align-items: center;
          i {
            position: absolute;
            left: -50px;
            font-size: 32px;
            color: #666;
          }
        }
        .intro-t-msg {
          font-size: 12px;
          color: #c4c4c4;
          padding: 5px 0;
        }
        .intro-t-contact {
          font-size: 14px;
          font-weight: 700;
          color: #393939;
          padding-top: 30px;
          .contactQQ {
            line-height: 28px;
            color: #9e9b99;
            span {
              padding-left: 26px;
              font-weight: 400;
              font-size: 12px;
              color: #1a6cd8;
            }
          }
          .contactPhone {
            line-height: 28px;
            color: #9e9b99;
            span {
              padding-left: 20px;
              font-weight: 400;
              font-size: 12px;
              color: #1a6cd8;
            }
          }
          .contactEmail {
            line-height: 28px;
            color: #9e9b99;
            span {
              padding-left: 20px;
              font-weight: 400;
              font-size: 12px;
              color: #1a6cd8;
            }
          }
        }
      }
      .details-intro-b {
        height: 50%;
        width: 80%;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 25px 25px 75px 50px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .intro-b-title {
          font-size: 14px;
          font-weight: 700;
          color: #666;
          padding: 10px 0;
          position: relative;
          display: flex;
          align-items: center;
          i {
            position: absolute;
            left: -50px;
            font-size: 32px;
            color: #666;
          }
        }
        .intro-b-msg {
          font-size: 12px;
          color: #c4c4c4;
          padding: 5px 0;
        }
        .intro-b-contact {
          font-size: 14px;
          font-weight: 700;
          color: #393939;
          padding-top: 30px;
          .contactDate {
            line-height: 28px;
            color: #9e9b99;
            span {
              padding-left: 20px;
              font-weight: 400;
              font-size: 12px;
              color: #333;
            }
          }
          .contactAddress {
            line-height: 28px;
            color: #9e9b99;
            span {
              padding-left: 20px;
              font-weight: 400;
              font-size: 12px;
              color: #333;
            }
          }
        }
      }
    }
    .details-map {
      flex: 1;
      .mapContent {
        width: 100%;
        height: 100%;
        padding: 75px 150px 75px 0;
        box-sizing: border-box;
        .mapContent-map {
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact/contact.vue